/**
 * String constants for the in-app bug-report UI.
 *
 * Kept in a single file so future i18n can swap them out without
 * touching component logic. No inline UI strings in the components.
 */

export const BUG_REPORT_STRINGS = {
  // Floating button
  buttonTooltip: 'Report a bug or improvement',
  buttonAriaLabel: 'Open bug report',

  // Modal — header
  modalTitle: 'Report a bug or improvement',
  modalDescription:
    'Help us improve Argus. We capture a screenshot of what you see plus a bit of context (route, browser, recent errors). Review the screenshot before submitting.',

  // Screenshot pane
  screenshotPaneAlt: 'Captured screenshot of the current view',
  screenshotMissing:
    'Screenshot capture failed — describe what you saw instead.',
  retake: 'Retake',
  remove: 'Remove',

  // Form fields
  titleLabel: 'Title (optional)',
  titlePlaceholder: 'Short summary',
  commentLabel: 'What happened?',
  commentPlaceholder:
    'What were you doing? What did you expect? What actually happened?',
  severityLabel: 'Severity',
  severityP0: 'P0 — Broken',
  severityP1: 'P1 — Degraded',
  severityP2: 'P2 — Polish',
  severityP3: 'P3 — Nice to have',
  moduleLabel: 'Module',

  // Privacy gate
  privacyHeading: 'Review before sending',
  privacyBody:
    'This screenshot may contain sensitive customer data. Make sure nothing confidential is visible.',
  privacyConfirm: 'Confirm send',
  privacyCancel: 'Cancel',

  // Submit
  submit: 'Submit',
  submitting: 'Submitting…',
  cancel: 'Cancel',

  // Submit results
  toastSubmittedNoUrl: 'Bug report submitted (GitHub URL pending)',
  toastSubmitted: (id: string | number) =>
    `Bug report #${id} submitted — view on GitHub`,
  toastViewOnGithub: 'View on GitHub',
  errorSubmitFailed: 'Failed to submit bug report — please try again.',
  errorRateLimited:
    'Too many reports right now. Please wait a minute and try again.',
  errorFeatureOff: 'Bug reporting is currently disabled by your administrator.',

  // Field validation
  errorCommentRequired: 'Please describe what happened.',
  errorCommentTooLong: 'Comment must be 5000 characters or fewer.',
  errorTitleTooLong: 'Title must be 100 characters or fewer.',
} as const;

export const MAX_TITLE_LENGTH = 100;
export const MAX_COMMENT_LENGTH = 5000;
